import dialogDrawerDefect from './dialogDrawerDefect.vue'

/* istanbul ignore next */
dialogDrawerDefect.install = function (app) {
  app.component(dialogDrawerDefect.name, dialogDrawerDefect)
}

export default dialogDrawerDefect


//////////////////
// WEBPACK FOOTER
// ./packages/dialogdrawerdefect/index.js
// module id = null
// module chunks = 